"use client";

import { ReactNode } from "react";

import PolicyActionLayout from "@/components/wrappers/policy-action-layout/policy-action-layout";

interface FooterContent {
  termsAndConditions?: string;
  termsOfBusiness?: string;
  privacyPolicy?: string;
  cookiePolicy?: string;
  accessibility?: string;
  copyrightText?: string;
}

interface WithdrawalLayoutWrapperProps {
  children: React.ReactNode;
  showFooter?: boolean;
  footerContent?: FooterContent;
  logoLinkUrl?: string;
  helpButton?: ReactNode;
}
function WithdrawalLayoutWrapper({
  children,
  showFooter = true,
  footerContent,
  logoLinkUrl,
  helpButton,
}: Readonly<WithdrawalLayoutWrapperProps>) {
  return (
    <PolicyActionLayout
      showFooter={showFooter}
      footerContent={footerContent}
      logoLinkUrl={logoLinkUrl}
      helpButton={helpButton}
    >
      {children}
    </PolicyActionLayout>
  );
}

export default WithdrawalLayoutWrapper;
